import { render, staticRenderFns } from "./dalog.vue?vue&type=template&id=1fe141e0&scoped=true&"
import script from "./dalog.vue?vue&type=script&lang=js&"
export * from "./dalog.vue?vue&type=script&lang=js&"
import style0 from "./dalog.vue?vue&type=style&index=0&id=1fe141e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe141e0",
  null
  
)

export default component.exports